<template>
  <div class="px-lg-4 px-3 xd-flex xflex-column" style="height: calc(100vh - 140px)">
    <ValidationObserver v-slot="{ invalid, dirty }" ref="formValidationObserver">
      <div class="page-header mb-4">
        <div class="d-flex justify-content-between p-0">
          <h3>Add/Edit Expenses</h3>
          <div>
            <b-btn variant="primary" @click="doSaveDamageRelatedExpenses" :disabled="invalid">Save</b-btn>
            <router-link :to="{name: 'EventManage', params: {id: eventId, tab: 'damages', tab: 'damages'}}">
              <b-btn variant="secondary">Close</b-btn>
            </router-link>
          </div>
        </div>
      </div>
      <div class="form-container overflow-auto h-100">
        <b-form class="h-100 mt-4">
          <div class="row h-100 mx-2">
            <div class="col-12">
              <div class="my-3 d-none">
                <h5 class="">Expenses</h5>
              </div>
              <div class="list-group">
                <div class="list-group-item d-md-block d-none" v-if="damageRelatedExpenses.length > 0">
                  <div class="row">
                    <div class="col-2 p-2"><strong>Type</strong></div>
                    <div class="col-3 p-2"><strong>Vendor/Other Name</strong></div>
                    <div class="col-4 p-2">
                      <strong class="flex-fill">Details</strong>
                    </div>
                    <div class="col-2 p-2"><strong>Amount</strong></div>
                  </div>
                </div>
                <div class="list-group-item" v-for="(expense, index) in damageRelatedExpenses" :key="index">
                  <div class="row">
                    <div class="col-md-2 col-12 px-2 mb-md-0 mb-2">
                      <b-form-group class="m-0">
                        <ValidationProvider name="ExpenseSource" rules="required" v-slot="validation" immediate>
                          <b-form-select :options="expenseSourceTypes" v-model="expense.expenseSource"
                            :state="spr2_getValidationState(validation)">
                            <template #first>
                              <b-form-select-option :value="null" disabled :state="Boolean(false)">Select a
                                Type</b-form-select-option>
                            </template>
                          </b-form-select>
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                    <div class="col-md-3 col-12 px-2 mb-md-0 mb-2">
                      <div v-if="expense.expenseSource == 0">
                        <b-form-group class="m-0">
                          <ValidationProvider name="Vendor" rules="required" v-slot="validation" immediate>
                            <b-form-select :options="propertyVendors" v-model="expense.vendorId"
                              :state="spr2_getValidationState(validation)">
                              <template #first>
                                <b-form-select-option :value="null" disabled>Select a Vendor</b-form-select-option>
                              </template>
                            </b-form-select>
                          </ValidationProvider>
                        </b-form-group>
                      </div>
                      <div v-else-if="expense.expenseSource == 1">
                        <b-form-group class="m-0">
                          <ValidationProvider name="Vendor" rules="required" v-slot="validation" immediate>
                            <b-form-input placeholder="Type Name" v-model="expense.otherName"
                              :state="spr2_getValidationState(validation)"></b-form-input>
                          </ValidationProvider>
                        </b-form-group>
                      </div>
                      <div v-else class="form-control">
                      </div>
                    </div>
                    <div class="col-md-4 col-12 pl-2 pr-3 mb-md-0 mb-2">
                      <b-form-group class="m-0">
                        <b-form-input placeholder="Expense Details" v-model="expense.detail"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-md-2 col-12 px-2 mb-md-0 mb-2">
                      <b-form-group class="m-0">
                        <b-form-input type="text" placeholder="$0" v-model="damageRelatedExpenseAmounts[index]"
                          v-currency-input :state="isAmountValid(damageRelatedExpenseAmounts[index])"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-md-1 col-12 d-flex align-items-center justify-content-md-center justify-content-end">
                      <i class="ml-4 fas fa-minus-circle text-danger align-self-center"
                        @click="removeDamageRelatedExpense(index)" title="Remove Expense"></i>
                    </div>
                  </div>
                </div>
                <div class="list-group-item bg-light py-2">
                  <div class="row">
                    <div class="col-md-9 col-3 d-flex justify-content-md-end align-items-center">
                      <strong v-if="damageRelatedExpenses.length > 0">Total Expense</strong>
                    </div>
                    <div class="col-md-1 col-3 d-flex align-items-center pr-0">
                      <div v-if="damageRelatedExpenses.length > 0">
                        <div>{{ (totalExpenses||0) | formatCurrency }}</div>
                      </div>
                    </div>
                    <div class="col d-flex justify-content-end px-2">
                      <a class="btn btn-sm btn-success text-white" @click="addDamageRelatedExpense"
                        title="Add Expense" v-if="damageRelatedExpenses.length > 0">
                        <i class="fas fa-plus-circle"></i> Expense
                      </a>
                    </div>
                    <div class="col-12 p-5 text-center" v-if="damageRelatedExpenses.length == 0">
                      <p class="text-muted">No expenses currently exist.</p>
                      <a class="btn btn-success text-white" @click="addDamageRelatedExpense"
                        title="Add Expense">
                        <i class="fas fa-plus-circle"></i> Expense
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { spr2Validation } from '../mixins/Spr2SharedFunctions'

export default {
  mixins: [spr2Validation],
  name: 'AddEditDamages',
  props: {
    eventId: {
      type: String,
      default: null
    },
    propertyId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      expenseSourceTypes: [
        {
          text: 'Vendor',
          value: 0
        },
        {
          text: 'Other',
          value: 1
        }
      ],
      damageRelatedExpenses: [],
      damageRelatedExpenseAmounts: [],
      propertyVendors: []
    }
  },
  computed: {
    totalExpenses () {
      let totalVal = this.damageRelatedExpenseAmounts.reduce((acc, curr) => acc + this.cleanseData(curr), 0)
      // console.log('total', totalVal)
      return totalVal
    }
  },
  async created () {
    await this.doLoadPropertyVendors()
    await this.doLoadDamageRelatedExpenses(this.eventId)
  },
  methods: {
    ...mapActions('events', ['getPropertyVendors', 'saveDamageRelatedExpenses', 'getDamageRelatedExpenses']),
    resetForm () {
      console.log('resetForm called')
    },
    async addDamageRelatedExpense () {
      this.damageRelatedExpenses.push({ id: null, expenseSource: null, vendorId: null, otherName: null, amount: null, detail: null })
      this.damageRelatedExpenseAmounts.push('')
    },
    async removeDamageRelatedExpense (index) {
      this.damageRelatedExpenses.splice(index, 1)
      this.damageRelatedExpenseAmounts.splice(index, 1)
    },
    async doSaveDamageRelatedExpenses () {
      let toSave = this.damageRelatedExpenses.map((x, index) => {
        let amount = this.cleanseData(this.damageRelatedExpenseAmounts[index])
        x.amount = amount
        return x
      })
      console.log(toSave)
      await this.saveDamageRelatedExpenses({eventId: this.eventId, damageRelatedExpenses: toSave})
      this.$router.push({ name: 'EventManage', params: { id: this.eventId, tab: 'damages' } })
      this.$toasted.show('Expenses Saved.', { duration: 3000 })
    },
    async doLoadPropertyVendors () {
      var response = await this.getPropertyVendors(this.propertyId)
      this.propertyVendors = response.data.vendors.map((v) => {
        return {text: v.name, value: v.id}
      })
    },
    async doLoadDamageRelatedExpenses (eventId) {
      this.getDamageRelatedExpenses(eventId).then((result) => {
        this.damageRelatedExpenses = result.data.damageRelatedExpenses
        this.damageRelatedExpenseAmounts = result.data.damageRelatedExpenses.map(e => {
          return this.$options.filters.formatCurrency(e.amount)
        })
        // console.log(this.damageRelatedExpenseAmounts)
      })
    },
    cleanseData (data) {
      if (data) {
        let newVal = parseFloat(data.toString().replaceAll('$', '').replaceAll(',', '') || 0)
        return newVal
      } else {
        return 0
      }
    },
    isAmountValid (amount) {
      let amt = this.cleanseData(amount)
      return (!isNaN(amt) && amt > 0)
    }
  }
}
</script>
